(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-rotator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rotator = document.querySelector('[data-rotator]');
    if (!rotator) return;

    const slides = rotator.querySelectorAll('[data-rotator-slide]');
    if (slides.length < 2) return;

    const dots = rotator.querySelectorAll('[data-rotator-dot]');
    const interval = Math.max(4000, parseInt(rotator.dataset.interval, 10) || 7500);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    let index = 0;
    let timer = null;

    const goTo = (i) => {
      index = (i + slides.length) % slides.length;
      slides.forEach((s, j) => s.classList.toggle('is-active', j === index));
      dots.forEach((d, j) => d.classList.toggle('is-active', j === index));
    };

    const start = () => {
      if (reducedMotion.matches) return;
      stop();
      timer = setInterval(() => goTo(index + 1), interval);
    };

    const stop = () => {
      if (timer) clearInterval(timer);
      timer = null;
    };

    dots.forEach((d) => {
      d.addEventListener('click', () => {
        goTo(parseInt(d.dataset.rotatorDot, 10));
        start();
      });
    });

    rotator.addEventListener('pointerenter', stop);
    rotator.addEventListener('pointerleave', start);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else start();
    });

    start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-increase], [data-qty-decrease]');
    if (!btn) return;
    const wrap = btn.closest('[data-qty]');
    const input = wrap && wrap.querySelector('[data-qty-input]');
    if (!input) return;
    const current = parseInt(input.value, 10) || 1;
    const next = btn.hasAttribute('data-qty-increase') ? current + 1 : current - 1;
    input.value = Math.min(99, Math.max(1, next));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-cart-auto-submit]');
    if (!input) return;
    const value = parseInt(input.value, 10);
    input.value = Number.isFinite(value) ? Math.min(99, Math.max(1, value)) : 1;
    const form = input.closest('form');
    if (form) form.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const toggle = document.querySelector('[data-filters-toggle]');
    const panel = document.querySelector('[data-collection-filters]');
    if (toggle && panel) {
      toggle.addEventListener('click', () => panel.classList.toggle('is-open'));
      document.addEventListener('click', (e) => {
        if (panel.classList.contains('is-open') && !panel.contains(e.target) && e.target !== toggle && !toggle.contains(e.target)) {
          panel.classList.remove('is-open');
        }
      });
    }

    document.querySelectorAll('[data-filter-checkbox]').forEach((box) => {
      box.addEventListener('change', () => box.closest('form').submit());
    });

    const sortSelect = document.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', () => sortSelect.closest('form').submit());
    }

    const clearBtn = document.querySelector('[data-filters-clear]');
    if (clearBtn) {
      const hasActive = document.querySelectorAll('[data-filter-checkbox]:checked').length > 0;
      clearBtn.classList.toggle('is-visible', hasActive);
      clearBtn.addEventListener('click', () => {
        const url = new URL(window.location.href);
        [...url.searchParams.keys()].forEach((key) => {
          if (key.indexOf('filter.') === 0) url.searchParams.delete(key);
        });
        window.location.href = url.toString();
      });
    }

    document.querySelectorAll('[data-price-filter]').forEach((wrap) => {
      const rangeMin = wrap.querySelector('[data-price-range-min]');
      const rangeMax = wrap.querySelector('[data-price-range-max]');
      const numberMin = wrap.querySelector('[data-price-number-min]');
      const numberMax = wrap.querySelector('[data-price-number-max]');
      const fill = wrap.querySelector('[data-price-fill]');
      const bounds = Number(wrap.dataset.rangeMax) || 0;
      if (!rangeMin || !rangeMax || !numberMin || !numberMax || !fill || bounds <= 0) return;

      const updateFill = () => {
        const min = Number(rangeMin.value);
        const max = Number(rangeMax.value);
        const minPercent = (min / bounds) * 100;
        const maxPercent = (max / bounds) * 100;
        fill.style.left = minPercent + '%';
        fill.style.right = (100 - maxPercent) + '%';
      };

      const submitForm = () => {
        const form = wrap.closest('form');
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      };

      rangeMin.addEventListener('input', () => {
        if (Number(rangeMin.value) > Number(rangeMax.value)) rangeMin.value = rangeMax.value;
        numberMin.value = rangeMin.value;
        updateFill();
      });

      rangeMax.addEventListener('input', () => {
        if (Number(rangeMax.value) < Number(rangeMin.value)) rangeMax.value = rangeMin.value;
        numberMax.value = rangeMax.value;
        updateFill();
      });

      rangeMin.addEventListener('change', submitForm);
      rangeMax.addEventListener('change', submitForm);

      numberMin.addEventListener('change', () => {
        let value = Math.min(Math.max(Number(numberMin.value) || 0, 0), Number(rangeMax.value));
        numberMin.value = value;
        rangeMin.value = value;
        updateFill();
        submitForm();
      });

      numberMax.addEventListener('change', () => {
        let value = Math.max(Math.min(Number(numberMax.value) || bounds, bounds), Number(rangeMin.value));
        numberMax.value = value;
        rangeMax.value = value;
        updateFill();
        submitForm();
      });

      updateFill();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.querySelectorAll('[data-footer-country]').forEach((select) => {
    select.addEventListener('change', () => {
      select.form.submit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('.site-header');
    if (header) {
      const onScroll = () => {
        header.classList.toggle('is-scrolled', window.scrollY > 8);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      const heroEl = document.querySelector('[data-transparent-header]');
      if (heroEl) {
        let heroObserver = null;
        const setupHeroObserver = () => {
          if (heroObserver) heroObserver.disconnect();
          const headerHeight = header.offsetHeight;
          heroObserver = new IntersectionObserver(
            (entries) => {
              header.classList.toggle('is-over-hero', entries[0].isIntersecting);
            },
            { rootMargin: `-${headerHeight}px 0px 0px 0px`, threshold: 0 }
          );
          heroObserver.observe(heroEl);
        };
        setupHeroObserver();
        window.addEventListener('resize', setupHeroObserver);
      }
    }

    document.querySelectorAll('[data-dialog-target]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const dialog = document.getElementById(btn.dataset.dialogTarget);
        if (!dialog) return;
        dialog.showModal();
        const input = dialog.querySelector('input');
        if (input) input.focus();
      });
    });

    document.querySelectorAll('[data-dialog-close]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const dialog = btn.closest('dialog');
        if (dialog) dialog.close();
      });
    });

    document.querySelectorAll('dialog.search-modal, dialog.menu-drawer').forEach((dialog) => {
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    });

    document.addEventListener('cart:refresh', async () => {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      } catch (err) {}
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-3d"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const hero = document.querySelector('[data-hero-3d]');
    if (!hero) return;

    const supportsWebGL = () => {
      try {
        const c = document.createElement('canvas');
        return !!(window.WebGLRenderingContext && (c.getContext('webgl') || c.getContext('experimental-webgl')));
      } catch (e) {
        return false;
      }
    };
    if (!supportsWebGL()) return;

    let PRODUCTS = [];
    try {
      PRODUCTS = JSON.parse(hero.dataset.items || '[]');
    } catch (e) {
      PRODUCTS = [];
    }
    if (!PRODUCTS.length) return;

    const loadScript = (src) =>
      new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });

    const loadLibs = async () => {
      if (!window.THREE) await loadScript(hero.dataset.threeSrc);
      if (!window.THREE.GLTFLoader) await loadScript(hero.dataset.gltfSrc);
      return window.THREE;
    };

    const init = (THREE) => {
      const mount = hero.querySelector('[data-hero-canvas]');
      if (!mount) return;

      const renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true, powerPreference: 'high-performance' });
      renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1.5));
      renderer.outputEncoding = THREE.sRGBEncoding;
      renderer.toneMapping = THREE.ACESFilmicToneMapping;
      renderer.toneMappingExposure = 1.12;
      renderer.shadowMap.enabled = true;
      renderer.shadowMap.type = THREE.PCFSoftShadowMap;
      mount.appendChild(renderer.domElement);

      const scene = new THREE.Scene();
      const camera = new THREE.PerspectiveCamera(35, 1, 0.1, 80);
      camera.position.set(0, 1.85, 9.2);

      scene.add(new THREE.AmbientLight(0x42474f, 1.35));
      scene.add(new THREE.HemisphereLight(0xfff0dd, 0x10131a, 0.5));

      const key = new THREE.DirectionalLight(0xffe2c4, 1.55);
      key.position.set(4, 7, 5);
      key.castShadow = true;
      key.shadow.mapSize.set(1024, 1024);
      key.shadow.camera.left = -5;
      key.shadow.camera.right = 5;
      key.shadow.camera.top = 6;
      key.shadow.camera.bottom = -1;
      key.shadow.bias = -0.0003;
      scene.add(key);
      scene.add(key.target);

      const rim = new THREE.PointLight(0xe09b5f, 1.5, 24, 1.5);
      rim.position.set(-4.5, 3, -3.5);
      scene.add(rim);
      const fill = new THREE.DirectionalLight(0xaec0e0, 0.45);
      fill.position.set(-4, 2.5, 6);
      scene.add(fill);
      scene.add(fill.target);

      const shadowPlane = new THREE.Mesh(new THREE.PlaneGeometry(30, 14), new THREE.ShadowMaterial({ opacity: 0.32 }));
      shadowPlane.rotation.x = -Math.PI / 2;
      shadowPlane.receiveShadow = true;
      scene.add(shadowPlane);

      const M = (color, o = {}) =>
        new THREE.MeshPhysicalMaterial(
          Object.assign({ color: new THREE.Color(color), roughness: 0.55, metalness: 0, clearcoat: 0.25, clearcoatRoughness: 0.5 }, o)
        );
      const v3 = (x, y, z) => new THREE.Vector3(x, y, z);
      const tube = (pts, r, mat, closed = false, seg = 64) =>
        new THREE.Mesh(new THREE.TubeGeometry(new THREE.CatmullRomCurve3(pts, closed), seg, r, 10, closed), mat);
      const dispSphere = (sx, sy, sz, fn, mat) => {
        const g = new THREE.SphereGeometry(1, 56, 40);
        const p = g.attributes.position;
        for (let i = 0; i < p.count; i++) {
          const x = p.getX(i), y = p.getY(i), z = p.getZ(i);
          const d = fn(x, y, z);
          p.setXYZ(i, x + (d.x || 0), y + (d.y || 0), z + (d.z || 0));
        }
        g.computeVertexNormals();
        const m = new THREE.Mesh(g, mat);
        m.scale.set(sx, sy, sz);
        return m;
      };
      const roundedRectShape = (w, h, r) => {
        const s = new THREE.Shape();
        s.moveTo(-w / 2 + r, -h / 2);
        s.lineTo(w / 2 - r, -h / 2);
        s.absarc(w / 2 - r, -h / 2 + r, r, -Math.PI / 2, 0);
        s.lineTo(w / 2, h / 2 - r);
        s.absarc(w / 2 - r, h / 2 - r, r, 0, Math.PI / 2);
        s.lineTo(-w / 2 + r, h / 2);
        s.absarc(-w / 2 + r, h / 2 - r, r, Math.PI / 2, Math.PI);
        s.lineTo(-w / 2, -h / 2 + r);
        s.absarc(-w / 2 + r, -h / 2 + r, r, Math.PI, Math.PI * 1.5);
        return s;
      };

      const builders = {
        loon(color) {
          const g = new THREE.Group();
          const mat = M(color || '#E23A6B', { roughness: 0.85, clearcoat: 0.1 });
          const B = [
            [0, 0.38, 0.2, 0.85, 0.68], [-0.82, 0.48, 0.58, 0.6, 1], [0.82, 0.48, 0.58, 0.6, 1], [0, 0.5, -0.6, 0.8, 0.9],
            [-1.08, 0.95, -0.08, 0.7, 1], [1.08, 0.95, -0.08, 0.7, 1], [0, 1.42, -0.78, 0.92, 1], [-0.68, 1.28, -0.55, 0.6, 1],
            [0.68, 1.28, -0.55, 0.6, 1], [-1.18, 1.58, -0.3, 0.3, 1], [1.22, 1.52, -0.32, 0.28, 1], [-0.52, 1.98, -0.68, 0.3, 1],
            [0.5, 2.02, -0.7, 0.26, 1], [-1.48, 0.6, 0.42, 0.26, 1], [1.48, 0.58, 0.45, 0.24, 1], [0, 2.2, -0.85, 0.22, 1],
          ];
          const geo = new THREE.SphereGeometry(1, 36, 26);
          B.forEach(([x, y, z, r, sy]) => {
            const m = new THREE.Mesh(geo, mat);
            m.position.set(x, y, z);
            m.scale.set(r, r * sy, r);
            g.add(m);
          });
          return g;
        },

        yasuke(color) {
          const g = new THREE.Group();
          const mat = M(color || '#F09BBE', { roughness: 0.4, clearcoat: 0.6 });
          const shape = new THREE.Shape();
          shape.moveTo(-0.62, -0.09);
          shape.lineTo(0.62, -0.09);
          shape.lineTo(0.62, 0.09);
          shape.lineTo(-0.62, 0.09);
          shape.closePath();
          const strip = (pts) => {
            const path = new THREE.CatmullRomCurve3(pts);
            return new THREE.Mesh(
              new THREE.ExtrudeGeometry(shape, { steps: 80, bevelEnabled: true, bevelThickness: 0.04, bevelSize: 0.04, bevelSegments: 3, extrudePath: path }),
              mat
            );
          };
          g.add(strip([v3(0, 0, -1.9), v3(0, 0.08, -1.15), v3(0, 0.13, -0.35), v3(0, 0.28, 0.35), v3(0, 0.65, 0.95), v3(0, 1.15, 1.25), v3(0, 1.65, 1.32), v3(0, 1.98, 1.15)]));
          g.add(strip([v3(0, 0, 0.55), v3(0, 0.06, 1.0), v3(0, 0.1, 1.55), v3(0, 0.24, 2.05), v3(0, 0.6, 2.45), v3(0, 1.05, 2.68), v3(0, 1.5, 2.7), v3(0, 1.82, 2.5)]));
          g.rotation.y = Math.PI / 2.3;
          return g;
        },

        pine(color) {
          const g = new THREE.Group();
          const copper = M(color || '#B06A3B', { roughness: 0.35, metalness: 0.85, clearcoat: 0 });
          const rad = (t) => 0.62 + 0.3 * Math.sin(Math.PI * Math.min(t, 1));
          for (let k = 0; k < 8; k++) {
            for (const dir of [1, -1]) {
              const pts = [];
              for (let i = 0; i <= 16; i++) {
                const t = i / 16;
                const a = dir * t * Math.PI * 1.7 + (k / 8) * Math.PI * 2;
                pts.push(v3(Math.cos(a) * rad(t), t * 1.7, Math.sin(a) * rad(t)));
              }
              g.add(tube(pts, 0.035, copper));
            }
          }
          const ringB = new THREE.Mesh(new THREE.TorusGeometry(0.62, 0.045, 8, 40), copper);
          ringB.rotation.x = Math.PI / 2;
          g.add(ringB);
          const leafMat = M('#3e6b4a', { roughness: 0.6 });
          for (let k = 0; k < 6; k++) {
            const leaf = new THREE.Mesh(new THREE.ConeGeometry(0.09, 1.0, 8), leafMat);
            const a = (k / 6) * Math.PI * 2;
            leaf.position.set(Math.cos(a) * 0.22, 2.1, Math.sin(a) * 0.22);
            leaf.rotation.z = Math.cos(a) * 0.5;
            leaf.rotation.x = -Math.sin(a) * 0.5;
            g.add(leaf);
          }
          return g;
        },

        eve(color) {
          const prof = [
            new THREE.Vector2(0.02, 0), new THREE.Vector2(0.55, 0), new THREE.Vector2(0.6, 0.06), new THREE.Vector2(0.3, 0.16),
            new THREE.Vector2(0.14, 0.5), new THREE.Vector2(0.1, 0.9), new THREE.Vector2(0.16, 1.15), new THREE.Vector2(0.5, 1.32),
            new THREE.Vector2(1.0, 1.4), new THREE.Vector2(1.0, 1.46), new THREE.Vector2(0.02, 1.46),
          ];
          const m = new THREE.Mesh(new THREE.LatheGeometry(prof, 48), M(color || '#EDEAE3', { roughness: 0.3, clearcoat: 0.7 }));
          const g = new THREE.Group();
          g.add(m);
          return g;
        },

        akasha(color) {
          const mat = M(color || '#F1EEE8', { roughness: 0.25, clearcoat: 0.8, clearcoatRoughness: 0.25 });
          const m = dispSphere(1.35, 0.95, 1.15, (x, y, z) => {
            const dip = Math.max(0, y) * Math.exp(-((x * x) / 0.42 + ((z - 0.05) * (z - 0.05)) / 0.75)) * -0.92;
            const rimD = Math.max(0, y) * Math.exp(-((x * x) / 0.9 + (z * z) / 1.3)) * 0.1;
            return { y: dip + rimD };
          }, mat);
          m.position.y = 0.78;
          const g = new THREE.Group();
          g.add(m);
          return g;
        },

        botenobo(color) {
          const g = new THREE.Group();
          const slabMat = M(color || '#2a2e35', { roughness: 0.6, clearcoat: 0.1 });
          const copper = M('#b06a3b', { roughness: 0.35, metalness: 0.8 });
          const slab1 = new THREE.Mesh(new THREE.BoxGeometry(2.6, 0.08, 1.2), slabMat);
          slab1.position.y = 0.62;
          const slab2 = new THREE.Mesh(new THREE.BoxGeometry(2.2, 0.08, 1.05), slabMat);
          slab2.position.set(0.55, 0.95, 0.1);
          slab2.rotation.y = 0.12;
          const colGeo = new THREE.ExtrudeGeometry(roundedRectShape(0.5, 0.5, 0.16), { depth: 0.95, bevelEnabled: true, bevelThickness: 0.04, bevelSize: 0.04, bevelSegments: 3 });
          const c1 = new THREE.Mesh(colGeo, copper);
          c1.rotation.x = -Math.PI / 2;
          c1.position.set(-0.5, 0, 0.25);
          const c2 = new THREE.Mesh(colGeo, copper);
          c2.rotation.x = -Math.PI / 2;
          c2.position.set(0.85, 0, -0.2);
          c2.scale.setScalar(0.8);
          g.add(slab1, slab2, c1, c2);
          return g;
        },

        bouche(color) {
          const mat = M(color || '#E8A87C', { roughness: 0.72, clearcoat: 0.2 });
          const m = dispSphere(1.5, 1.0, 1.15, (x, y, z) => {
            const wing = Math.pow(Math.max(0, -x - 0.1), 1.3) * Math.max(0, y) * 1.35;
            const dip = Math.max(0, y) * Math.exp(-((x - 0.35) * (x - 0.35)) / 0.5 - (z * z) / 0.7) * -0.62;
            const frontDrop = Math.max(0, -z) * Math.max(0, y) * -0.22;
            return { y: dip + wing + frontDrop };
          }, mat);
          m.position.y = 0.85;
          m.rotation.y = 0.35;
          const g = new THREE.Group();
          g.add(m);
          return g;
        },

        limbus(color) {
          const g = new THREE.Group();
          const mat = M(color || '#33373e', { roughness: 0.55, clearcoat: 0.15 });
          const top1 = new THREE.Mesh(new THREE.BoxGeometry(2.7, 0.07, 1.15), mat);
          top1.position.set(-0.6, 0.78, 0);
          top1.rotation.z = 0.05;
          top1.rotation.y = 0.06;
          const top2 = new THREE.Mesh(new THREE.BoxGeometry(2.4, 0.07, 1.05), mat);
          top2.position.set(0.9, 0.5, 0.12);
          top2.rotation.z = -0.03;
          const tri = new THREE.Shape();
          tri.moveTo(0, 0);
          tri.lineTo(0.9, 0);
          tri.lineTo(0.28, 0.78);
          tri.closePath();
          const supGeo = new THREE.ExtrudeGeometry(tri, { depth: 0.5, bevelEnabled: false });
          const s1 = new THREE.Mesh(supGeo, mat);
          s1.position.set(-0.85, 0, -0.25);
          const s2 = new THREE.Mesh(supGeo, mat);
          s2.position.set(0.55, 0, -0.2);
          s2.scale.set(-0.9, 0.68, 0.9);
          const base = new THREE.Mesh(new THREE.BoxGeometry(3.4, 0.05, 1.3), mat);
          base.position.set(0.2, 0.025, 0);
          base.rotation.y = 0.04;
          g.add(top1, top2, s1, s2, base);
          return g;
        },

        lume(color) {
          const outer = roundedRectShape(2.1, 1.05, 0.34);
          outer.holes.push(roundedRectShape(1.62, 0.6, 0.22));
          const geo = new THREE.ExtrudeGeometry(outer, { depth: 1.05, bevelEnabled: true, bevelThickness: 0.05, bevelSize: 0.05, bevelSegments: 4, curveSegments: 24 });
          const m = new THREE.Mesh(geo, M(color || '#7a6a55', { roughness: 0.35, metalness: 0.75 }));
          m.position.set(0, 0.525, -0.5);
          const g = new THREE.Group();
          g.add(m);
          return g;
        },

        nats(color) {
          const mat = M(color || '#f0ede6', { roughness: 0.3, clearcoat: 0.7 });
          const geo = new THREE.BoxGeometry(2.3, 0.72, 0.95, 44, 10, 18);
          const p = geo.attributes.position;
          for (let i = 0; i < p.count; i++) {
            const x = p.getX(i), y = p.getY(i), z = p.getZ(i);
            let ny = y;
            if (y > 0) ny += Math.cos((x / 2.3) * Math.PI * 2.0) * 0.12 * (1 - Math.abs(z) / 0.6);
            const edge = 1 - Math.pow(Math.abs(x) / 1.15, 6) * 0.18 - Math.pow(Math.abs(z) / 0.475, 6) * 0.18;
            p.setXYZ(i, x * edge, ny * edge, z * edge);
          }
          geo.computeVertexNormals();
          const m = new THREE.Mesh(geo, mat);
          m.position.y = 0.38;
          const g = new THREE.Group();
          g.add(m);
          return g;
        },

        noi(color) {
          const g = new THREE.Group();
          const black = M(color || '#101114', { roughness: 0.25, clearcoat: 0.8 });
          const red = M('#d8261c', { roughness: 0.3, clearcoat: 0.6 });
          const b1 = new THREE.Mesh(new THREE.BoxGeometry(1.5, 0.78, 1.0), black);
          b1.position.set(-0.55, 0.39, 0);
          b1.rotation.y = 0.07;
          const b2 = new THREE.Mesh(new THREE.BoxGeometry(1.4, 0.68, 0.95), black);
          b2.position.set(0.62, 0.34, 0.05);
          b2.rotation.y = -0.09;
          const penta = (cx, s, rot) => {
            const pts = [];
            for (let i = 0; i < 5; i++) {
              const a = rot + (i / 5) * Math.PI * 2;
              pts.push(v3(cx + Math.cos(a + 0.4) * 0.12, 0.45 + Math.sin(a) * s * 0.8 + 0.1, Math.cos(a) * s));
            }
            return pts;
          };
          g.add(tube(penta(-1.28, 0.62, 0.3), 0.045, red, true));
          g.add(tube(penta(1.32, 0.5, 1.2), 0.04, red, true));
          g.add(tube([v3(-1.2, 0.9, 0.3), v3(-0.2, 1.05, 0.1), v3(0.9, 0.85, -0.2)], 0.035, red));
          g.add(b1, b2);
          return g;
        },

        araxys(color) {
          const g = new THREE.Group();
          const mat = M(color || '#7e838b', { roughness: 0.3, clearcoat: 0.7 });
          const ring = new THREE.Mesh(new THREE.TorusGeometry(0.95, 0.3, 18, 48), mat);
          ring.rotation.x = Math.PI / 2;
          ring.scale.set(1, 1, 0.62);
          ring.position.y = 0.45;
          for (let k = 0; k < 4; k++) {
            const a = (k / 4) * Math.PI * 2 + 0.4;
            const pts = [
              v3(Math.cos(a) * 0.85, 0.2, Math.sin(a) * 0.85),
              v3(Math.cos(a + 1.2) * 0.45, 0.95, Math.sin(a + 1.2) * 0.45),
              v3(Math.cos(a + 2.4) * 0.8, 0.3, Math.sin(a + 2.4) * 0.8),
            ];
            g.add(tube(pts, 0.09, mat));
          }
          const base = new THREE.Mesh(new THREE.CylinderGeometry(0.55, 0.62, 0.1, 32), mat);
          base.position.y = 0.05;
          g.add(ring, base);
          return g;
        },

        aether(color) {
          const g = new THREE.Group();
          const mat = M(color || '#e7e2d5', { roughness: 0.4, clearcoat: 0.4 });
          const seatY = 0.85, W = 0.95, D = 0.85;
          const leg = (x, z, lean) => tube([v3(x, seatY, z), v3(x * 1.5 + lean.x, 0.35, z * 1.5 + lean.z), v3(x * 1.9 + lean.x, 0, z * 1.9 + lean.z)], 0.05, mat);
          g.add(leg(W, D, { x: 0.1, z: 0 }), leg(-W, D, { x: -0.1, z: 0 }), leg(W, -D, { x: 0.15, z: -0.05 }), leg(-W, -D, { x: -0.15, z: -0.05 }));
          const seatPts = [
            v3(-W, seatY, D), v3(0, seatY - 0.12, D * 1.05), v3(W, seatY, D), v3(W * 1.05, seatY + 0.05, 0), v3(W, seatY + 0.1, -D),
            v3(0, seatY + 0.05, -D * 1.1), v3(-W, seatY + 0.1, -D), v3(-W * 1.05, seatY + 0.05, 0),
          ];
          g.add(tube(seatPts, 0.06, mat, true));
          const backPts = [v3(-W, seatY + 0.1, -D), v3(-0.55, 1.7, -D * 1.15), v3(0, 1.85, -D * 1.2), v3(0.55, 1.7, -D * 1.15), v3(W, seatY + 0.1, -D)];
          g.add(tube(backPts, 0.055, mat));
          for (let i = 0; i < 7; i++) {
            const t = i / 6;
            const bx = -W + t * 2 * W;
            g.add(tube([v3(bx, seatY + 0.05, -D * 1.05), v3(bx * 0.8, seatY + 0.55 + Math.sin(t * Math.PI) * 0.5, -D * 1.12), v3(bx * 0.55, 1.6 + Math.sin(t * Math.PI) * 0.15, -D * 1.16)], 0.022, mat));
            g.add(tube([v3(-W + t * 2 * W, seatY, D * 0.95), v3((-W + t * 2 * W) * 0.82, seatY - 0.1, 0), v3((-W + t * 2 * W) * 0.9, seatY + 0.02, -D * 0.95)], 0.02, mat));
          }
          return g;
        },

        lusio(color) {
          const s = new THREE.Shape();
          s.moveTo(-2.0, 0);
          s.lineTo(-1.55, 0.55);
          s.lineTo(0.15, 0.62);
          s.lineTo(1.9, 2.2);
          s.lineTo(2.25, 2.2);
          s.lineTo(2.35, 1.95);
          s.lineTo(0.55, 0.28);
          s.lineTo(-1.7, 0.2);
          s.lineTo(-1.75, 0.06);
          s.lineTo(-1.35, 0);
          s.closePath();
          const geo = new THREE.ExtrudeGeometry(s, { depth: 0.8, bevelEnabled: true, bevelThickness: 0.05, bevelSize: 0.05, bevelSegments: 3, curveSegments: 12 });
          const m = new THREE.Mesh(geo, M(color || '#7a2734', { roughness: 0.4, metalness: 0.25, clearcoat: 0.5 }));
          m.position.z = -0.4;
          const g = new THREE.Group();
          g.add(m);
          return g;
        },
      };

      const normalize = (obj, target = 2.15) => {
        const box = new THREE.Box3().setFromObject(obj);
        const size = box.getSize(new THREE.Vector3());
        const scale = target / Math.max(size.x, size.y, size.z, 0.001);
        obj.scale.setScalar(scale);
        const box2 = new THREE.Box3().setFromObject(obj);
        const center = box2.getCenter(new THREE.Vector3());
        obj.position.x -= center.x;
        obj.position.z -= center.z;
        obj.position.y -= box2.min.y;
        obj.traverse((n) => {
          if (n.isMesh) {
            n.castShadow = true;
            n.receiveShadow = true;
          }
        });
      };

      const collectMats = (obj) => {
        const set = new Set();
        obj.traverse((n) => {
          if (n.isMesh) (Array.isArray(n.material) ? n.material : [n.material]).forEach((m) => set.add(m));
        });
        return [...set];
      };

      const gltfLoader = new THREE.GLTFLoader();
      const items = [];
      PRODUCTS.forEach((p) => {
        const slot = new THREE.Group();
        const spin = new THREE.Group();
        slot.add(spin);
        scene.add(slot);
        const item = { ...p, slot, spin, mats: [], cur: { x: 8, y: 0, z: -6, s: 0.001, o: 0 } };
        items.push(item);
        if (p.glb) {
          gltfLoader.load(
            p.glb,
            (gltf) => {
              const holder = new THREE.Group();
              holder.add(gltf.scene);
              normalize(gltf.scene);
              spin.add(holder);
              item.mats = collectMats(holder);
              item.mats.forEach((m) => {
                m.transparent = true;
              });
            },
            undefined,
            () => {}
          );
        } else if (builders[p.key]) {
          const model = builders[p.key](p.color);
          normalize(model);
          spin.add(model);
          item.mats = collectMats(model);
          item.mats.forEach((m) => {
            m.transparent = true;
          });
        }
      });

      hero.classList.add('is-interactive');
      const hint = hero.querySelector('[data-hero-hint]');
      if (hint) hint.hidden = false;

      let active = 0;
      const infoEl = hero.querySelector('[data-hero-info]');
      const nameEl = hero.querySelector('[data-hero-name]');
      const catEl = hero.querySelector('[data-hero-cat]');
      const priceEl = hero.querySelector('[data-hero-price]');
      const viewEl = hero.querySelector('[data-hero-view]');
      const addEl = hero.querySelector('[data-hero-add]');
      const bigEl = hero.querySelector('[data-hero-bigname]');
      const dotsEl = hero.querySelector('[data-hero-dots]');

      PRODUCTS.forEach((_, i) => {
        const d = document.createElement('i');
        if (i === 0) d.className = 'is-active';
        dotsEl.appendChild(d);
      });

      let addTimer = null;
      const syncInfo = () => {
        const p = PRODUCTS[active];
        infoEl.classList.add('is-fading');
        bigEl.classList.add('is-fading');
        clearTimeout(addTimer);
        setTimeout(() => {
          nameEl.textContent = p.name;
          catEl.textContent = p.cat;
          priceEl.textContent = p.price;
          bigEl.textContent = p.name;
          viewEl.href = p.url;
          addEl.disabled = !p.available;
          addEl.classList.remove('is-added');
          addEl.dataset.variant = p.variant || '';
          infoEl.classList.remove('is-fading');
          bigEl.classList.remove('is-fading');
        }, 260);
        [...dotsEl.children].forEach((d, i) => d.classList.toggle('is-active', i === active));
      };
      syncInfo();

      addEl.addEventListener('click', async () => {
        const variantId = parseInt(addEl.dataset.variant, 10);
        if (!variantId) return;
        addEl.disabled = true;
        document.dispatchEvent(new CustomEvent('cart:fly', { detail: { sourceEl: addEl } }));
        try {
          await fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
          });
          addEl.classList.add('is-added');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch (e) {}
        addEl.disabled = false;
      });

      const rel = (i) => {
        let d = i - active;
        const n = items.length;
        if (d > n / 2) d -= n;
        if (d < -n / 2) d += n;
        return d;
      };

      const slotFor = (d) => {
        if (d === 0) return { x: 0, y: 0, z: 0, s: 1, o: 1 };
        if (d === -1) return { x: -3.7, y: 0, z: -1.9, s: 0.55, o: 0.3 };
        if (d === 1) return { x: 3.7, y: 0, z: -1.9, s: 0.55, o: 0.3 };
        if (d === -2) return { x: -6.3, y: 0, z: -4, s: 0.3, o: 0 };
        if (d === 2) return { x: 6.3, y: 0, z: -4, s: 0.3, o: 0 };
        return { x: d > 0 ? 8 : -8, y: 0, z: -6, s: 0.001, o: 0 };
      };

      const spin = { y: 0, x: 0, vel: 0 };
      let autoTimer = null;
      const stopAuto = () => {
        if (autoTimer) clearInterval(autoTimer);
        autoTimer = null;
      };
      const startAuto = () => {
        stopAuto();
        autoTimer = setInterval(() => go(1, true), 5500);
      };
      const go = (dir, fromAuto) => {
        active = (active + dir + items.length) % items.length;
        spin.y = 0;
        spin.x = 0;
        spin.vel = 0;
        syncInfo();
        if (!fromAuto) startAuto();
      };
      hero.querySelector('[data-hero-prev]').addEventListener('click', () => go(-1));
      hero.querySelector('[data-hero-next]').addEventListener('click', () => go(1));
      startAuto();

      const infoPanel = hero.querySelector('.hero-3d__info');
      if (infoPanel) {
        infoPanel.addEventListener('pointerenter', stopAuto);
        infoPanel.addEventListener('pointerleave', () => {
          if (!dragging) startAuto();
        });
      }

      let dragging = false, lastX = 0, lastY = 0, lastDx = 0, downX = 0, downT = 0;
      hero.addEventListener('pointerdown', (e) => {
        if (e.target.closest('a, button')) return;
        dragging = true;
        lastX = e.clientX;
        lastY = e.clientY;
        lastDx = 0;
        downX = e.clientX;
        downT = performance.now();
        hero.classList.add('is-grabbing');
        stopAuto();
      });
      window.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        const dx = e.clientX - lastX, dy = e.clientY - lastY;
        lastX = e.clientX;
        lastY = e.clientY;
        lastDx = dx;
        spin.y += dx * 0.008;
        spin.x = Math.max(-0.6, Math.min(0.65, spin.x + dy * 0.005));
      });
      window.addEventListener('pointerup', (e) => {
        if (!dragging) return;
        dragging = false;
        hero.classList.remove('is-grabbing');
        spin.vel = lastDx * 0.004;
        const dt = performance.now() - downT, dx = e.clientX - downX;
        if (dt < 350 && Math.abs(dx) > 90) {
          go(dx < 0 ? 1 : -1);
        } else {
          startAuto();
        }
      });

      const resize = () => {
        const w = mount.clientWidth, h = mount.clientHeight;
        if (!w || !h) return;
        renderer.setSize(w, h, false);
        camera.aspect = w / h;
        camera.updateProjectionMatrix();
      };
      resize();
      window.addEventListener('resize', resize);

      let running = true;
      const clock = new THREE.Clock();
      const frame = () => {
        requestAnimationFrame(frame);
        if (!running) return;
        const t = clock.getElapsedTime();

        if (!dragging) {
          spin.y += 0.008 + spin.vel;
          spin.vel *= 0.95;
          spin.x += (0 - spin.x) * 0.04;
        }

        items.forEach((it, i) => {
          const d = rel(i);
          const tgt = slotFor(d);
          const c = it.cur;
          const L = 0.085;
          c.x += (tgt.x - c.x) * L;
          c.y += (tgt.y - c.y) * L;
          c.z += (tgt.z - c.z) * L;
          c.s += (tgt.s - c.s) * L;
          c.o += (tgt.o - c.o) * L;
          it.slot.position.set(c.x, c.y + 0.65 + (d === 0 ? Math.sin(t * 0.6) * 0.04 : 0), c.z);
          it.slot.scale.setScalar(Math.max(c.s, 0.001));
          it.mats.forEach((m) => {
            m.opacity = c.o;
          });
          it.slot.visible = c.o > 0.01;
          if (d === 0) {
            it.spin.rotation.y = spin.y + t * 0.12;
            it.spin.rotation.x = spin.x;
          } else {
            it.spin.rotation.y = t * 0.09 + d * 0.5;
            it.spin.rotation.x *= 0.94;
          }
        });

        camera.lookAt(0, 1.35, 0);
        renderer.render(scene, camera);
      };
      frame();

      const visibility = new IntersectionObserver(
        (entries) => {
          running = entries[0].isIntersecting && !document.hidden;
        },
        { threshold: 0 }
      );
      visibility.observe(hero);
      document.addEventListener('visibilitychange', () => {
        running = !document.hidden;
      });
    };

    let started = false;
    const boot = () => {
      if (started) return;
      started = true;
      loadLibs()
        .then((THREE) => init(THREE))
        .catch(() => {});
    };

    const lazy = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        lazy.disconnect();
        boot();
      },
      { rootMargin: '200px' }
    );
    lazy.observe(hero);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-network"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Decrypt/scramble text reveal for the category links, played once
    // automatically on load — the signature transition from the reference
    // video, applied without altering any existing colors/layout/copy.
    const links = document.querySelectorAll('.hero-network__link');
    if (!links.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const CHARS = '!<>-_\\/[]{}=+*^?#$%&';

    const scramble = (el, delay) => {
      const finalText = el.textContent.trim();
      const length = finalText.length;
      el.setAttribute('aria-label', finalText);
      const revealAt = Array.from({ length }, () => 6 + Math.floor(Math.random() * 14));
      let frame = 0;

      const tick = () => {
        let out = '';
        let done = 0;
        for (let i = 0; i < length; i++) {
          if (finalText[i] === ' ') {
            out += ' ';
            done++;
          } else if (frame >= revealAt[i]) {
            out += finalText[i];
            done++;
          } else {
            out += CHARS[(Math.random() * CHARS.length) | 0];
          }
        }
        el.textContent = out;
        frame++;
        if (done < length) requestAnimationFrame(tick);
      };

      el.textContent = finalText.replace(/\S/g, CHARS[0]);
      setTimeout(() => requestAnimationFrame(tick), delay);
    };

    links.forEach((el, i) => scramble(el, 200 + i * 160));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-360"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-product-360]');
    if (!root) return;

    const glbSrc = root.dataset.glbSrc;
    if (!glbSrc) return;

    const supportsWebGL = () => {
      try {
        const c = document.createElement('canvas');
        return !!(window.WebGLRenderingContext && (c.getContext('webgl') || c.getContext('experimental-webgl')));
      } catch (e) {
        return false;
      }
    };
    if (!supportsWebGL()) return;

    const loadScript = (src) =>
      new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });

    const loadLibs = async () => {
      if (!window.THREE) await loadScript(root.dataset.threeSrc);
      if (!window.THREE.GLTFLoader) await loadScript(root.dataset.gltfSrc);
      return window.THREE;
    };

    const init = (THREE) => {
      const mount = root.querySelector('[data-product-360-canvas]');
      const hint = root.querySelector('[data-product-360-hint]');
      if (!mount) return;

      const renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true, powerPreference: 'high-performance' });
      renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1.5));
      renderer.outputEncoding = THREE.sRGBEncoding;
      renderer.toneMapping = THREE.ACESFilmicToneMapping;
      renderer.toneMappingExposure = 1.1;
      renderer.shadowMap.enabled = true;
      renderer.shadowMap.type = THREE.PCFSoftShadowMap;
      mount.appendChild(renderer.domElement);

      const scene = new THREE.Scene();
      const camera = new THREE.PerspectiveCamera(32, 1, 0.1, 80);
      camera.position.set(0, 1.55, 7.4);
      camera.lookAt(0, 1.0, 0);

      scene.add(new THREE.AmbientLight(0x42474f, 1.35));
      scene.add(new THREE.HemisphereLight(0xfff0dd, 0x10131a, 0.55));

      const key = new THREE.DirectionalLight(0xffe2c4, 1.5);
      key.position.set(4, 7, 5);
      key.castShadow = true;
      key.shadow.mapSize.set(1024, 1024);
      key.shadow.bias = -0.0003;
      scene.add(key);
      scene.add(key.target);

      const rim = new THREE.PointLight(0xe09b5f, 1.4, 22, 1.5);
      rim.position.set(-4, 3, -3);
      scene.add(rim);

      const fill = new THREE.DirectionalLight(0xaec0e0, 0.4);
      fill.position.set(-4, 2.5, 6);
      scene.add(fill);

      const shadowPlane = new THREE.Mesh(new THREE.PlaneGeometry(14, 14), new THREE.ShadowMaterial({ opacity: 0.3 }));
      shadowPlane.rotation.x = -Math.PI / 2;
      shadowPlane.receiveShadow = true;
      scene.add(shadowPlane);

      const spin = new THREE.Group();
      scene.add(spin);

      const normalize = (obj, target = 2.2) => {
        const box = new THREE.Box3().setFromObject(obj);
        const size = box.getSize(new THREE.Vector3());
        const scale = target / Math.max(size.x, size.y, size.z, 0.001);
        obj.scale.setScalar(scale);
        const box2 = new THREE.Box3().setFromObject(obj);
        const center = box2.getCenter(new THREE.Vector3());
        obj.position.x -= center.x;
        obj.position.z -= center.z;
        obj.position.y -= box2.min.y;
        obj.traverse((n) => {
          if (n.isMesh) {
            n.castShadow = true;
            n.receiveShadow = true;
          }
        });
      };

      let modelReady = false;
      const gltfLoader = new THREE.GLTFLoader();
      gltfLoader.load(
        glbSrc,
        (gltf) => {
          normalize(gltf.scene);
          spin.add(gltf.scene);
          modelReady = true;
          if (hint) hint.classList.add('is-visible');
        },
        undefined,
        () => {}
      );

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      let dragging = false;
      let lastX = 0;
      let velocity = 0;
      mount.addEventListener('pointerdown', (e) => {
        dragging = true;
        lastX = e.clientX;
        velocity = 0;
        mount.setPointerCapture(e.pointerId);
      });
      mount.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        const dx = e.clientX - lastX;
        lastX = e.clientX;
        velocity = dx * 0.01;
        spin.rotation.y += velocity;
      });
      const stopDrag = () => {
        dragging = false;
      };
      mount.addEventListener('pointerup', stopDrag);
      mount.addEventListener('pointercancel', stopDrag);

      let visible = false;
      const io = new IntersectionObserver(
        (entries) => entries.forEach((entry) => {
          visible = entry.isIntersecting;
        }),
        { threshold: 0.15 }
      );
      io.observe(root);

      const resize = () => {
        const w = mount.clientWidth || 1;
        const h = mount.clientHeight || 1;
        renderer.setSize(w, h, false);
        camera.aspect = w / h;
        camera.updateProjectionMatrix();
      };
      resize();
      window.addEventListener('resize', resize);

      const tick = () => {
        requestAnimationFrame(tick);
        if (!visible) return;
        if (!dragging) {
          velocity *= 0.94;
          spin.rotation.y += velocity;
          if (modelReady && !reducedMotion.matches) {
            spin.rotation.y += 0.0035;
          }
        }
        renderer.render(scene, camera);
      };
      tick();
    };

    loadLibs().then(init).catch(() => {});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-showcase]');
    if (!section) return;

    let PRODUCTS = [];
    try {
      PRODUCTS = JSON.parse(section.dataset.items || '[]');
    } catch (e) {
      PRODUCTS = [];
    }
    if (!PRODUCTS.length) return;

    const cardHasCat = (cardEl, cat) => {
      try {
        return JSON.parse(cardEl.dataset.cats || '[]').includes(cat);
      } catch (e) {
        return false;
      }
    };

    const cardHTML = (p) => {
      const wrap = document.createElement('a');
      wrap.className = 'showcase-card';
      wrap.dataset.cat = p.cat || '';
      wrap.dataset.cats = JSON.stringify(p.cats || []);
      wrap.href = p.url || '#';

      const img = document.createElement('img');
      img.src = p.img;
      img.alt = p.name || '';
      img.loading = 'lazy';
      wrap.appendChild(img);

      const popup = document.createElement('div');
      popup.className = 'showcase-card__popup';
      popup.innerHTML = `
        <div class="showcase-card__popup-name"></div>
        <div class="showcase-card__popup-desc"></div>
        <span class="showcase-card__popup-cta"></span>
      `;
      popup.querySelector('.showcase-card__popup-name').textContent = p.name || '';
      popup.querySelector('.showcase-card__popup-desc').textContent = (p.cat || '') + ' · El işçiliği ile üretilmiş tasarım.';
      popup.querySelector('.showcase-card__popup-cta').textContent = section.dataset.viewLabel || 'Ürünü İncele';
      wrap.appendChild(popup);

      const overlay = document.createElement('div');
      overlay.className = 'showcase-card__overlay';
      overlay.innerHTML = `
        <div class="showcase-card__cat"></div>
        <div class="showcase-card__row">
          <div>
            <div class="showcase-card__name"></div>
            <div class="showcase-card__price"></div>
          </div>
        </div>
      `;
      overlay.querySelector('.showcase-card__cat').textContent = p.cat || '';
      overlay.querySelector('.showcase-card__name').textContent = p.name || '';
      overlay.querySelector('.showcase-card__price').textContent = p.price || '';

      const addBtn = document.createElement('button');
      addBtn.type = 'button';
      addBtn.className = 'showcase-card__add';
      addBtn.setAttribute('aria-label', section.dataset.addLabel || 'Sepete ekle');
      addBtn.textContent = '+';
      addBtn.disabled = !p.available;
      addBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!p.variant) return;
        addBtn.disabled = true;
        document.dispatchEvent(new CustomEvent('cart:fly', { detail: { sourceEl: img } }));
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: p.variant, quantity: 1 }] }),
          });
          addBtn.classList.add('is-added');
          addBtn.textContent = '✓';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch (err) {}
        addBtn.disabled = false;
      });
      overlay.querySelector('.showcase-card__row').appendChild(addBtn);
      wrap.appendChild(overlay);

      return wrap;
    };

    const cols = [...section.querySelectorAll('[data-showcase-col]')];
    const half = [[], []];
    PRODUCTS.forEach((p, i) => half[i % 2].push(p));
    cols.forEach((col, i) => {
      const list = half[i];
      [...list, ...list].forEach((p) => col.appendChild(cardHTML(p)));
    });

    const filtersEl = section.querySelector('[data-showcase-filters]');
    const cats = [...new Set(PRODUCTS.flatMap((p) => (p.cats && p.cats.length ? p.cats : [])))];
    cats.forEach((cat) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'showcase__filter';
      btn.dataset.filter = cat;
      btn.textContent = cat;
      filtersEl.appendChild(btn);
    });

    /* ---- otomatik dikey kayma (JS-driven, filtre odaklanması için) ---- */
    const rightEl = section.querySelector('.showcase__right');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const offsets = [0, 0];
    const dirs = [-1, 1];
    const speeds = [16, 15];
    let colHeights = [0, 0];
    let paused = false;
    let resumeTimer = null;

    const measure = () => {
      colHeights = cols.map((c) => c.scrollHeight / 2);
      if (offsets[1] === 0) offsets[1] = -colHeights[1];
    };
    measure();
    window.addEventListener('resize', measure);
    setTimeout(measure, 400);

    let lastT = performance.now();
    const tick = (now) => {
      requestAnimationFrame(tick);
      const dt = Math.min((now - lastT) / 1000, 0.1);
      lastT = now;
      if (!paused && !reducedMotion.matches) {
        cols.forEach((col, i) => {
          const h = colHeights[i];
          if (!h) return;
          offsets[i] += dirs[i] * speeds[i] * dt;
          offsets[i] = ((offsets[i] % h) + h) % h;
          offsets[i] -= h;
          col.style.transform = `translateY(${offsets[i]}px)`;
        });
      }
    };
    requestAnimationFrame(tick);

    rightEl.addEventListener('pointerenter', () => {
      paused = true;
      clearTimeout(resumeTimer);
    });
    rightEl.addEventListener('pointerleave', () => {
      paused = false;
    });

    const focusOnCategory = (cat) => {
      if (cat === 'all') {
        paused = false;
        return;
      }
      const containerH = rightEl.clientHeight;
      cols.forEach((col, i) => {
        const card = [...col.children].find((c) => cardHasCat(c, cat));
        const h = colHeights[i];
        if (!card || !h) return;
        const cardCenter = card.offsetTop + card.offsetHeight / 2;
        let target = containerH / 2 - cardCenter;
        target = ((target % h) + h) % h;
        target -= h;
        offsets[i] = target;
        col.classList.add('is-focusing');
        col.style.transform = `translateY(${target}px)`;
      });
      paused = true;
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(() => {
        cols.forEach((c) => c.classList.remove('is-focusing'));
        paused = false;
      }, 2800);
    };

    filtersEl.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-filter]');
      if (!btn) return;
      filtersEl.querySelectorAll('.showcase__filter').forEach((b) => b.classList.toggle('is-active', b === btn));
      const f = btn.dataset.filter;
      section.querySelectorAll('.showcase-card').forEach((c) => {
        c.classList.toggle('is-dim', f !== 'all' && !cardHasCat(c, f));
      });
      focusOnCategory(f);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-product-stage3d]');
    if (!root) return;

    const glbSrc = root.dataset.glbSrc;
    if (!glbSrc) return;

    const supportsWebGL = () => {
      try {
        const c = document.createElement('canvas');
        return !!(window.WebGLRenderingContext && (c.getContext('webgl') || c.getContext('experimental-webgl')));
      } catch (e) {
        return false;
      }
    };
    if (!supportsWebGL()) return;

    const loadScript = (src) =>
      new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });

    const loadLibs = async () => {
      if (!window.THREE) await loadScript(root.dataset.threeSrc);
      if (!window.THREE.GLTFLoader) await loadScript(root.dataset.gltfSrc);
      return window.THREE;
    };

    const init = (THREE) => {
      const mount = root.querySelector('[data-stage3d-canvas]');
      const hint = root.querySelector('[data-stage3d-hint]');
      const slideEl = root.closest('.product-gallery__slide');
      if (!mount) return;

      const renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true, powerPreference: 'high-performance' });
      renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1.5));
      renderer.outputEncoding = THREE.sRGBEncoding;
      renderer.toneMapping = THREE.ACESFilmicToneMapping;
      renderer.toneMappingExposure = 1.1;
      renderer.shadowMap.enabled = true;
      renderer.shadowMap.type = THREE.PCFSoftShadowMap;
      mount.appendChild(renderer.domElement);

      const scene = new THREE.Scene();
      const camera = new THREE.PerspectiveCamera(32, 1, 0.1, 80);
      camera.position.set(0, 1.5, 7.2);
      camera.lookAt(0, 1.05, 0);

      scene.add(new THREE.AmbientLight(0x42474f, 1.35));
      scene.add(new THREE.HemisphereLight(0xfff0dd, 0x10131a, 0.5));

      const key = new THREE.DirectionalLight(0xffe2c4, 1.55);
      key.position.set(4, 7, 5);
      key.castShadow = true;
      key.shadow.mapSize.set(1024, 1024);
      key.shadow.bias = -0.0003;
      scene.add(key);
      scene.add(key.target);

      const rim = new THREE.PointLight(0xe09b5f, 1.4, 22, 1.5);
      rim.position.set(-4, 3, -3);
      scene.add(rim);

      const fill = new THREE.DirectionalLight(0xaec0e0, 0.45);
      fill.position.set(-4, 2.5, 6);
      scene.add(fill);

      const shadowPlane = new THREE.Mesh(new THREE.PlaneGeometry(14, 14), new THREE.ShadowMaterial({ opacity: 0.3 }));
      shadowPlane.rotation.x = -Math.PI / 2;
      shadowPlane.receiveShadow = true;
      scene.add(shadowPlane);

      const spin = new THREE.Group();
      scene.add(spin);

      const normalize = (obj, target = 2.3) => {
        const box = new THREE.Box3().setFromObject(obj);
        const size = box.getSize(new THREE.Vector3());
        const scale = target / Math.max(size.x, size.y, size.z, 0.001);
        obj.scale.setScalar(scale);
        const box2 = new THREE.Box3().setFromObject(obj);
        const center = box2.getCenter(new THREE.Vector3());
        obj.position.x -= center.x;
        obj.position.z -= center.z;
        obj.position.y -= box2.min.y;
        obj.traverse((n) => {
          if (n.isMesh) {
            n.castShadow = true;
            n.receiveShadow = true;
          }
        });
      };

      let modelReady = false;
      const gltfLoader = new THREE.GLTFLoader();
      gltfLoader.load(
        glbSrc,
        (gltf) => {
          normalize(gltf.scene);
          spin.add(gltf.scene);
          modelReady = true;
          if (hint) hint.classList.add('is-visible');
        },
        undefined,
        () => {}
      );

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      let dragging = false;
      let lastX = 0;
      let velocity = 0;
      mount.addEventListener('pointerdown', (e) => {
        dragging = true;
        lastX = e.clientX;
        velocity = 0;
        mount.setPointerCapture(e.pointerId);
      });
      mount.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        const dx = e.clientX - lastX;
        lastX = e.clientX;
        velocity = dx * 0.01;
        spin.rotation.y += velocity;
      });
      const stopDrag = () => {
        dragging = false;
      };
      mount.addEventListener('pointerup', stopDrag);
      mount.addEventListener('pointercancel', stopDrag);

      let visible = false;
      const io = new IntersectionObserver(
        (entries) => entries.forEach((entry) => {
          visible = entry.isIntersecting;
        }),
        { threshold: 0.15 }
      );
      io.observe(root);

      const resize = () => {
        const w = mount.clientWidth || 1;
        const h = mount.clientHeight || 1;
        renderer.setSize(w, h, false);
        camera.aspect = w / h;
        camera.updateProjectionMatrix();
      };
      resize();
      window.addEventListener('resize', resize);

      const tick = () => {
        requestAnimationFrame(tick);
        const slideActive = !slideEl || slideEl.classList.contains('is-active');
        if (!visible || !slideActive) return;
        if (!dragging) {
          velocity *= 0.94;
          spin.rotation.y += velocity;
          if (modelReady && !reducedMotion.matches) {
            spin.rotation.y += 0.0035;
          }
        }
        renderer.render(scene, camera);
      };
      tick();
    };

    loadLibs().then(init).catch(() => {});
  })();

  (() => {
    document.querySelectorAll('[data-hero-gallery-row]').forEach((row) => {
      const gallery = row.querySelector('[data-product-gallery]');
      const hero = row.closest('.product-hero');
      if (!gallery || !hero) return;
      const backdrops = hero.querySelectorAll('[data-hero-backdrop]');
      const slides3d = [...gallery.querySelectorAll('.product-gallery__slide')];
      const modelSlideIndex = slides3d.findIndex((s) => s.classList.contains('product-gallery__slide--3d'));
      gallery.addEventListener('gallery:change', (e) => {
        backdrops.forEach((el) => {
          el.classList.toggle('is-active', Number(el.dataset.backdropIndex) === e.detail.index);
        });
        hero.classList.toggle('is-gallery-3d-active', modelSlideIndex !== -1 && e.detail.index === modelSlideIndex);
      });

      const main = row.querySelector('.product-gallery__main');
      const zoomInBtn = row.querySelector('[data-zoom-in]');
      const zoomOutBtn = row.querySelector('[data-zoom-out]');
      const zoomLevelEl = row.querySelector('[data-zoom-level]');
      if (!main || !zoomInBtn || !zoomOutBtn) return;

      const ZOOM_STEP = 0.6;
      const ZOOM_MAX = 3;
      const ZOOM_MIN = 1;
      let zoom = 1;
      let panX = 0;
      let panY = 0;
      let dragging = false;
      let dragStart = null;

      const activeImg = () => main.querySelector('.product-gallery__slide.is-active .product-gallery__zoom img');

      const clampPan = (img) => {
        const maxX = (img.clientWidth * (zoom - 1)) / 2;
        const maxY = (img.clientHeight * (zoom - 1)) / 2;
        panX = Math.max(-maxX, Math.min(maxX, panX));
        panY = Math.max(-maxY, Math.min(maxY, panY));
      };

      const applyZoom = () => {
        const img = activeImg();
        if (!img) return;
        clampPan(img);
        img.style.transform = `translate(${panX}px, ${panY}px) scale(${zoom})`;
        img.style.cursor = zoom > ZOOM_MIN ? 'grab' : 'zoom-in';
        if (zoomLevelEl) zoomLevelEl.textContent = Math.round(zoom * 100) + '%';
        zoomOutBtn.disabled = zoom <= ZOOM_MIN;
        zoomInBtn.disabled = zoom >= ZOOM_MAX;
      };

      const resetZoom = () => {
        if (dragging) return;
        zoom = 1;
        panX = 0;
        panY = 0;
        const img = activeImg();
        if (img) {
          img.style.transform = '';
          img.style.cursor = 'zoom-in';
        }
        if (zoomLevelEl) zoomLevelEl.textContent = '100%';
        zoomOutBtn.disabled = true;
        zoomInBtn.disabled = false;
      };

      zoomInBtn.addEventListener('click', () => {
        zoom = Math.min(ZOOM_MAX, zoom + ZOOM_STEP);
        applyZoom();
      });

      zoomOutBtn.addEventListener('click', () => {
        zoom = Math.max(ZOOM_MIN, zoom - ZOOM_STEP);
        if (zoom === ZOOM_MIN) {
          panX = 0;
          panY = 0;
        }
        applyZoom();
      });

      gallery.addEventListener('gallery:change', resetZoom);
      row.addEventListener('mouseleave', resetZoom);

      // The zoom controls sit next to (not inside) the gallery element, so
      // forward hover state to it — otherwise moving the cursor onto the
      // controls looks like leaving the gallery and autoplay resumes mid-zoom.
      row.addEventListener('mouseenter', () => gallery.dispatchEvent(new Event('mouseenter')));
      row.addEventListener('mouseleave', () => gallery.dispatchEvent(new Event('mouseleave')));

      const DRAG_THRESHOLD = 4;
      let dragMoved = false;

      main.addEventListener('pointerdown', (e) => {
        // Capturing the pointer here retargets the browser's synthesized
        // 'click' event to `main` itself for anything under it — including
        // the nav/dot/thumb buttons — which silently breaks their own click
        // handling. Skip entirely when the press starts on one of those.
        if (e.target.closest('[data-gallery-prev], [data-gallery-next], [data-gallery-dot], [data-gallery-thumb]')) {
          return;
        }
        const img = activeImg();
        if (!img) return;
        dragging = true;
        dragMoved = false;
        dragStart = { x: e.clientX - panX, y: e.clientY - panY, clientX: e.clientX, clientY: e.clientY };
        img.style.cursor = zoom > ZOOM_MIN ? 'grabbing' : 'zoom-in';
        if (main.setPointerCapture) main.setPointerCapture(e.pointerId);
      });

      main.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        const img = activeImg();
        if (!img) return;
        if (
          Math.abs(e.clientX - dragStart.clientX) > DRAG_THRESHOLD ||
          Math.abs(e.clientY - dragStart.clientY) > DRAG_THRESHOLD
        ) {
          dragMoved = true;
        }
        if (zoom > ZOOM_MIN) {
          panX = e.clientX - dragStart.x;
          panY = e.clientY - dragStart.y;
          img.classList.add('is-dragging');
          applyZoom();
        }
      });

      const endDrag = () => {
        dragging = false;
        const img = activeImg();
        if (img) {
          img.classList.remove('is-dragging');
          img.style.cursor = zoom > ZOOM_MIN ? 'grab' : 'zoom-in';
        }
      };

      main.addEventListener('pointerup', endDrag);
      main.addEventListener('pointercancel', endDrag);

      // The zoom decision lives on 'click' (fired after pointerup on a real
      // press-and-release) rather than pointerup itself, so it still works
      // in environments that don't dispatch a full pointer event sequence.
      main.addEventListener('click', (e) => {
        if (e.target.closest('[data-gallery-prev], [data-gallery-next], [data-gallery-dot], [data-gallery-thumb]')) {
          return;
        }
        if (dragMoved) {
          dragMoved = false;
          return;
        }
        if (zoom >= ZOOM_MAX) {
          zoom = 1;
          panX = 0;
          panY = 0;
        } else {
          zoom = Math.min(ZOOM_MAX, zoom + ZOOM_STEP);
        }
        applyZoom();
        const img = activeImg();
        if (img) img.style.cursor = zoom > ZOOM_MIN ? 'grab' : 'zoom-in';
      });
    });

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-qty-increase], [data-qty-decrease]');
      if (!btn) return;
      const wrap = btn.closest('[data-qty]');
      const input = wrap && wrap.querySelector('[data-qty-input]');
      if (!input) return;
      const current = parseInt(input.value, 10) || 1;
      const next = btn.hasAttribute('data-qty-increase') ? current + 1 : current - 1;
      input.value = Math.min(99, Math.max(1, next));
    });

    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('.product-hero__form');
      if (!form) return;
      e.preventDefault();

      const submitBtn = form.querySelector('[data-add-to-cart-btn]');
      if (!submitBtn || submitBtn.disabled) return;
      submitBtn.disabled = true;

      submitBtn.classList.remove('is-zapping', 'is-pulsing');
      void submitBtn.offsetWidth;
      submitBtn.classList.add('is-zapping', 'is-pulsing');

      const label = submitBtn.querySelector('[data-submit-label]');
      const originalLabel = label.textContent;
      label.innerHTML =
        '<svg class="product-hero__submit-check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 13l4 4L19 7"/></svg>' +
        submitBtn.dataset.addedLabel;

      setTimeout(() => {
        submitBtn.classList.remove('is-zapping', 'is-pulsing');
        label.textContent = originalLabel;
      }, 750);

      const hero = form.closest('.product-hero');
      const img =
        (hero && hero.querySelector('.product-gallery__slide.is-active .product-gallery__zoom img')) ||
        (hero && hero.querySelector('.product-gallery__slide.is-active img')) ||
        (hero && hero.querySelector('.product-gallery__slide img'));
      document.dispatchEvent(new CustomEvent('cart:fly', { detail: { sourceEl: img } }));

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        if (!res.ok) throw new Error('cart add failed');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(() => {
          window.location.href = '/cart';
        }, 900);
      } catch (err) {
        submitBtn.disabled = false;
        form.submit();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var modal = null;
    var imgEl = null;
    var counterEl = null;
    var prevBtn = null;
    var nextBtn = null;
    var closeBtn = null;
    var gallery = [];
    var activeIndex = 0;
    var lastFocused = null;
    var strings = { close: 'Close', previous: 'Previous image', next: 'Next image', zoomIn: 'Zoom in', zoomOut: 'Zoom out' };

    function labels(grid) {
      var i18n = grid.closest('.project-page').querySelector('.project-lightbox-i18n');
      return {
        close: (i18n && i18n.getAttribute('data-close')) || 'Close',
        previous: (i18n && i18n.getAttribute('data-previous')) || 'Previous image',
        next: (i18n && i18n.getAttribute('data-next')) || 'Next image',
        zoomIn: (i18n && i18n.getAttribute('data-zoom-in')) || 'Zoom in',
        zoomOut: (i18n && i18n.getAttribute('data-zoom-out')) || 'Zoom out'
      };
    }

    function buildModal(strings) {
      if (modal) return modal;

      modal = document.createElement('div');
      modal.className = 'project-lightbox';
      modal.hidden = true;
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');

      var backdrop = document.createElement('div');
      backdrop.className = 'project-lightbox__backdrop';
      backdrop.setAttribute('data-lightbox-close', '');

      var stage = document.createElement('div');
      stage.className = 'project-lightbox__stage';

      closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'project-lightbox__btn project-lightbox__btn--close';
      closeBtn.setAttribute('data-lightbox-close', '');
      closeBtn.innerHTML = '&times;';

      prevBtn = document.createElement('button');
      prevBtn.type = 'button';
      prevBtn.className = 'project-lightbox__btn project-lightbox__btn--prev';
      prevBtn.innerHTML = '&#8249;';

      nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'project-lightbox__btn project-lightbox__btn--next';
      nextBtn.innerHTML = '&#8250;';

      var frame = document.createElement('div');
      frame.className = 'project-lightbox__frame';

      imgEl = document.createElement('img');
      imgEl.className = 'project-lightbox__img';
      imgEl.alt = '';
      frame.appendChild(imgEl);

      counterEl = document.createElement('p');
      counterEl.className = 'project-lightbox__counter';

      stage.appendChild(closeBtn);
      stage.appendChild(prevBtn);
      stage.appendChild(frame);
      stage.appendChild(nextBtn);
      stage.appendChild(counterEl);

      modal.appendChild(backdrop);
      modal.appendChild(stage);
      document.body.appendChild(modal);

      closeBtn.addEventListener('click', closeLightbox);
      backdrop.addEventListener('click', closeLightbox);
      prevBtn.addEventListener('click', function () {
        showImage(activeIndex - 1);
      });
      nextBtn.addEventListener('click', function () {
        showImage(activeIndex + 1);
      });

      imgEl.addEventListener('click', function (event) {
        if (imgEl.classList.contains('is-zoomed')) {
          imgEl.classList.remove('is-zoomed');
          imgEl.style.transformOrigin = '';
          imgEl.setAttribute('aria-label', strings.zoomIn);
          return;
        }
        var rect = imgEl.getBoundingClientRect();
        var xPct = ((event.clientX - rect.left) / rect.width) * 100;
        var yPct = ((event.clientY - rect.top) / rect.height) * 100;
        imgEl.style.transformOrigin = xPct + '% ' + yPct + '%';
        imgEl.classList.add('is-zoomed');
        imgEl.setAttribute('aria-label', strings.zoomOut);
      });

      document.addEventListener('keydown', function (event) {
        if (!modal || modal.hidden) return;
        if (event.key === 'Escape') closeLightbox();
        if (event.key === 'ArrowLeft') showImage(activeIndex - 1);
        if (event.key === 'ArrowRight') showImage(activeIndex + 1);
      });

      applyLabels(strings);

      return modal;
    }

    function applyLabels(newStrings) {
      strings = newStrings;
      closeBtn.setAttribute('aria-label', strings.close);
      prevBtn.setAttribute('aria-label', strings.previous);
      nextBtn.setAttribute('aria-label', strings.next);
    }

    function showImage(index) {
      if (!gallery.length) return;
      activeIndex = (index + gallery.length) % gallery.length;
      var item = gallery[activeIndex];

      imgEl.classList.remove('is-zoomed');
      imgEl.style.transformOrigin = '';
      imgEl.src = item.src;
      imgEl.alt = item.caption || '';
      imgEl.setAttribute('aria-label', strings.zoomIn);
      counterEl.textContent = (activeIndex + 1) + ' / ' + gallery.length;

      var multiple = gallery.length > 1;
      prevBtn.hidden = !multiple;
      nextBtn.hidden = !multiple;
      counterEl.hidden = !multiple;
    }

    function openLightbox(grid, triggers, index, triggerEl) {
      var gridStrings = labels(grid);
      buildModal(gridStrings);
      applyLabels(gridStrings);

      gallery = triggers.map(function (el) {
        return { src: el.getAttribute('data-full'), caption: el.getAttribute('data-caption') };
      });
      lastFocused = triggerEl;

      showImage(index);
      modal.hidden = false;
      document.documentElement.classList.add('project-lightbox-open');
      closeBtn.focus();
    }

    function closeLightbox() {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      document.documentElement.classList.remove('project-lightbox-open');
      if (lastFocused) lastFocused.focus();
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-lightbox-trigger]');
      if (!trigger) return;

      var grid = trigger.closest('[data-project-gallery]');
      if (!grid) return;

      var triggers = Array.prototype.slice.call(grid.querySelectorAll('[data-lightbox-trigger]'));
      var index = triggers.indexOf(trigger);

      openLightbox(grid, triggers, index, trigger);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["studio-about"] && !Shopify.designMode) return;
  try {
    
  const animateStats = (container) => {
    container.querySelectorAll('[data-stat-value]').forEach((el) => {
      const target = Number(el.dataset.statValue) || 0;
      const duration = 1200;
      const start = performance.now();
      const tick = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(target * eased);
        if (progress < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    });
  };

  document.querySelectorAll('[data-about-stats]').forEach((container) => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateStats(container);
            io.disconnect();
          }
        });
      },
      { threshold: 0.4 }
    );
    io.observe(container);
  });

  } catch(e) { console.error(e); }
})();
})();
